import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'

export const onTapUp = object(tapUp, {
  hooks: array([
    preventDefault,
    stopImmediatePropagation
  ]),
  task: ({ ownerDocument, href, dataset }) => {
    const { defaultView } = ownerDocument
    const { windowFeatures } = dataset

    defaultView.open(href, 'popupWindow', `popup,${windowFeatures}`)
  }
})

export default anchor => onTapUp.listen(anchor)
